import React from 'react'
import { HomeHeading } from '../page/home/Heading'

interface Props {
  title?: string | null
  subTitle?: string | null
}

const LandingHero: React.FC<Props> = ({ title, subTitle }) => (
  <section className="flex justify-center py-8 md:py-12 lg:py-14">
    <div className="container flex flex-col items-center px-4 space-y-4 lg:space-y-8">
      <HomeHeading tag="h1">{title}</HomeHeading>

      {subTitle && (
        <h2 className="px-10 text-lg text-center xl:text-2xl lg:text-xl text-night">
          {subTitle}
        </h2>
      )}
    </div>
  </section>
)

export default LandingHero
